import { RefObject, useEffect } from 'react';

type UseComposerTextareaParams = {
  textareaRef: RefObject<HTMLTextAreaElement>;
  value: string;
  maxHeight?: number;
};

export const useComposerTextarea = ({
  textareaRef,
  value,
  maxHeight = 200,
}: UseComposerTextareaParams) => {
  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, maxHeight)}px`;
  }, [textareaRef, value, maxHeight]);
};
